<div class="section" style="width: 400px; height: 650px; flex: 1; display: flex; flex-direction: column;" data-cy="tooth-surface-picker">
  <div class="section-header" data-cy="tooth-surface-picker-header">
    <div class="section-header-title" data-cy="tooth-surface-picker-title">Select Tooth Surface</div>
  </div>
  <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="tooth-surface-picker-spinner"></app-tdo-progress-spinner>
  <div class="section-content" style="display: flex; flex-direction: column; flex: 1;" *ngIf="!isLoading" data-cy="tooth-surface-picker-content">
    <div *ngIf="!isLoading" style="height: 535px;" data-cy="tooth-surface-picker-list-container">

      <div *ngFor="let tooth of dataPatientCaseWorkItemToothSurfaces" data-cy="tooth-surface-picker-tooth-group">
        <b data-cy="tooth-surface-picker-tooth-label">Tooth #{{ tooth.ToothDescription }}</b>
        <div *ngFor="let toothSurface of vvToothSurfaces" data-cy="tooth-surface-picker-surface-container">
          <div style="display: flex; align-items: center" *ngIf="showSurfaceForTooth(tooth.ToothID, toothSurface.ValidValueItemId)" data-cy="tooth-surface-picker-surface-row">
<!--          <div style="display: flex; align-items: center">-->
              <div style="flex-basis: 250px; padding-right:10px; padding-top:8px; margin-left:10px" data-cy="tooth-surface-picker-checkbox-container">
                <mat-checkbox class="example-margin"
                              [checked]="toothSurfaceSelected(tooth.ToothID, toothSurface.ValidValueItemId)"
                              [color]="'primary'"
                              (change)="toothSurfaceCheckChange(tooth.CaseWorkItemToothID, tooth.ToothID, toothSurface.ValidValueItemId, $event)"
                              data-cy="tooth-surface-picker-checkbox-{{toothSurface.ValidValueItemId}}">
                  {{ toothSurface.ItemDisplayValue }}
                </mat-checkbox>
              </div>

          </div>
        </div>
      </div>
    </div>

    <div class="action-container" data-cy="tooth-surface-picker-actions">
      <button class="tdo-button tdo-save" style="margin-right: 12px;" (click)="saveSelection()" data-cy="tooth-surface-picker-save-btn">Save Selection(s)</button>
      <button class="tdo-button tdo-close" style="margin-right: 12px;" (click)="cancel(false)" data-cy="tooth-surface-picker-close-btn">Close</button>
    </div>

  </div>
</div>
